import { ComponentConfig } from "@puckeditor/core";
import {
  AnnouncementBar,
  AnnouncementBarSettings,
  defaultAnnouncementBarSettings,
} from "@/components/AnnouncementBar";

export type AnnouncementBarProps = AnnouncementBarSettings & {
  source?: "global" | "page";
};

export const AnnouncementBarBlock: ComponentConfig<AnnouncementBarProps> = {
  label: "Header Announcement Marquee",
  fields: {
    source: {
      type: "radio",
      label: "Content Source",
      options: [
        { label: "Global Header Settings", value: "global" },
        { label: "This Page", value: "page" },
      ],
    },
    enabled: {
      type: "radio",
      label: "Visible",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    items: {
      type: "array",
      label: "Announcements",
      getItemSummary: (item) => item.boldText || item.text || "Announcement",
      arrayFields: {
        boldText: { type: "text", label: "Bold Lead Text" },
        text: { type: "text", label: "Full Message" },
        icon: {
          type: "select",
          label: "Icon",
          options: [
            { label: "Quality Shield", value: "shield" },
            { label: "Turnaround Clock", value: "clock" },
            { label: "Order Box", value: "box" },
          ],
        },
      },
      defaultItemProps: {
        boldText: "New trust point",
        text: "New trust point with a concise supporting detail",
        icon: "shield",
      },
    },
    speedSeconds: {
      type: "number",
      label: "Loop Duration (12–90 seconds)",
      min: 12,
      max: 90,
    },
    pauseOnHover: {
      type: "radio",
      label: "Pause on Hover",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
  },
  defaultProps: {
    ...defaultAnnouncementBarSettings,
    source: "global",
  },
  // The public renderer lifts this block into the site header. This rendering is
  // only visible inside Puck and gives page-level overrides a truthful preview.
  render: ({ source, ...settings }) => source === "page" ? (
    <div style={{ position: "relative", zIndex: 2 }}>
      <AnnouncementBar {...settings} />
    </div>
  ) : (
    <div className="mx-auto my-3 max-w-4xl rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-3 text-center text-sm font-semibold text-slate-600">
      Using the global announcement marquee from Header Settings
    </div>
  ),
};
